import { cloneElement, isValidElement, ReactNode } from 'react';
import { FloatingPortal } from '@floating-ui/react';
import { getFloatingHostElement } from './utils';
import {
  FloatingLayerProvider,
  useFloatingLayerContext,
} from './FloatingLayerContext';

interface IProps {
  children: ReactNode;
}

const FloatingLayer = ({ children }: IProps) => {
  const zIndex = useFloatingLayerContext();

  return (
    <FloatingPortal root={getFloatingHostElement()}>
      <FloatingLayerProvider>
        {isValidElement(children) &&
          cloneElement(children, {
            ...children.props,
            style: {
              ...children.props.style,
              zIndex,
            },
          })}
      </FloatingLayerProvider>
    </FloatingPortal>
  );
};

export default FloatingLayer;
